import { Link,useLocation } from 'react-router-dom';

type NavItem={label:string;route:string;active:(path:string)=>boolean;primary?:boolean};
const items:NavItem[]=[
 {label:'Sales Home',route:'/sales',active:p=>p==='/sales'||p.startsWith('/sales/account/')},
 {label:'Leads',route:'/sales/leads',active:p=>p==='/sales/leads'||p.startsWith('/sales/lead/')},
 {label:'Opportunities',route:'/sales/opportunities',active:p=>p.startsWith('/sales/opportunities')},
 {label:'Quotes',route:'/sales/commercial',active:p=>p.startsWith('/sales/commercial')},
 {label:'Orders',route:'/sales/orders',active:p=>p.startsWith('/sales/orders')},
 {label:'New Record',route:'/sales/new',active:p=>p==='/sales/new',primary:true},
];

export function SalesNav(){
 const {pathname}=useLocation();
 return <>{items.map(item=><Link key={item.route} to={item.route} className={`button-link sales-module-link${item.active(pathname)?' active':''}${item.primary?' sales-new-record':''}`}>{item.label}</Link>)}</>;
}
